// extracted by mini-css-extract-plugin
export default {"CountriesFeature":"vz_a bhp_b"};